import { render, staticRenderFns } from "./LinksModal.vue?vue&type=template&id=3ef6906f&scoped=true&"
import script from "./LinksModal.vue?vue&type=script&lang=ts&"
export * from "./LinksModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef6906f",
  null
  
)

export default component.exports